var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStrikeThrough = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.217 4C9.847 4 8 5.83 8 8c0 .723.205 1.408.566 2H6.352A5.81 5.81 0 0 1 6 8c0-3.353 2.824-6 6.217-6 2.527 0 4.723 1.458 5.693 3.583l-1.82.83C15.45 5.01 13.97 4 12.217 4ZM16 16c0-.723-.205-1.408-.566-2h2.214A5.81 5.81 0 0 1 18 16c0 3.353-2.824 6-6.217 6-2.527 0-4.723-1.458-5.693-3.583l1.82-.83C8.55 18.99 10.03 20 11.783 20 14.153 20 16 18.17 16 16ZM2 13h20v-2H2v2Z",
  fill: "currentColor"
})));
export default SvgStrikeThrough;